module.exports = __webpack_public_path__ + "static/paypal-9e01fd9ae07b4741031bdebd81989d82.png";